import React from 'react';
import { Modal } from 'react-bootstrap';
import ImageViewer from 'react-simple-image-viewer';
import pdf from 'ui/assets/pdf.png';
import xlsx from 'ui/assets/xlsx.png';

const initialState = {
  isPdfopen: false,
  pdfFile: null,
  isOpen: false,
  imgFile: null,
  current: 0,
  data: null,
};

const PODViewer = ({
  items,
  imgStyle,
  imgClass,
  wrapperClass,
  imgWrapperClass,
}) => {
  const [{ isOpen, current, data, isPdfopen, pdfFile }, setState] =
    React.useState(initialState);

  const openImageViewer = React.useCallback((index) => {
    setState((prevState) => ({ ...prevState, current: index, isOpen: true }));
  }, []);

  const closeImageViewer = () => {
    setState((prevState) => ({ ...prevState, current: 0, isOpen: false }));
  };

  React.useEffect(() => {
    if (items) {
      let im = [];

      items?.forEach((d) => {
        const payload = d?.replace('_thumb', '');
        im?.push(payload);
      });

      setState((prevState) => ({ ...prevState, data: im }));
    }
  }, [items]);

  if (!data) return null;

  return (
    <>
      <div className={wrapperClass}>
        {items?.map((d, i) => (
          <div className={imgWrapperClass}>
            <img
              key={i}
              className={imgClass}
              src={`${d?.includes('.pdf') ? pdf : d?.includes('.xlsx') ? xlsx : d}`}
              alt=""
              style={imgStyle}
              onClick={() => {
                d?.includes('.pdf')
                  ? setState((prevState) => ({
                      ...prevState,
                      isPdfopen: true,
                      pdfFile: d,
                    }))
                  : d?.includes('.xlsx') ?
                    window.open(d, '_blank')
                  : openImageViewer(i);
              }}
            />
          </div>
        ))}
      </div>

      {isOpen && (
        <ImageViewer
          src={data}
          currentIndex={current}
          onClose={closeImageViewer}
          disableScroll={false}
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.9)',
          }}
          closeOnClickOutside={true}
        />
      )}

      {/* pdf open */}
      <Modal
        show={isPdfopen}
        onHide={() =>
          setState((prevState) => ({ ...prevState, isPdfopen: false }))
        }
        className="text-center bg-transparent"
        contentClassName="bg-transparent "
        centered
        size="xl"
      >
        <Modal.Body className="bg-transparent" style={{ height: '95vh' }}>
          <div
            className="btn-close"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isPdfopen: false }))
            }
          />

          <iframe
            title=" "
            src={pdfFile}
            style={{
              width: '100%',
              height: '100%',
            }}
            frameBorder="0"
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PODViewer;
